export const verificationCode = {
  title: 'Verificação do e-mail',
  subtitle:
    'Acabamos de enviar um código de acesso para <strong>{{email}}</strong>. Por favor, informe no campo abaixo.',
  resendConfirmationCode: 'Enviamos o código para o e-mail informado.',
  putReceivedCode: 'Digitar código enviado',
  return: 'Retornar',
  userForm: {
    code: 'Código enviado',
    tooltip: {
      code: 'Se o código de verificação não chegar, clique em solicitar novo código.',
      noResendCodeAllowed:
        'Se o código de verificação não chegar, aguarde alguns minutos ou retorne para o login.',
    },
  },
  buttons: {
    next: 'Avançar',
    getNewCode: 'Solicitar novo código {{timer}}',
  },
  validation: {
    confirmationCode: {
      required: 'Campo obrigatório',
    },
  },
  shareCodeWarning:
    'Nunca pedimos seu código por e-mail, SMS, telefone, whatsapp ou qualquer outro canal. Não compartilhe ele com ninguém.',
};
